import React, { useEffect } from "react";
import Header from '../components/Header';
import Footer from '../components/Footer';
import "./AboutUs.css";

const AboutUs = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const originalTitle = document.title;
    document.title = `About Us - ${originalTitle}`;

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <div className="aboutus-page shared-background">
      <div className="aboutus-inner">
        <Header />
        <section className="aboutus-section">
          <h1 className="aboutus-title">About us</h1>
          <p className="aboutus-text">
            Welcome to <strong>CH Dropshipping</strong> – your trusted global dropshipping partner.<br />
            We empower eCommerce entrepreneurs to scale their businesses effortlessly through reliable sourcing, streamlined fulfillment, and exclusive product collections you won't find anywhere else.
          </p>
        </section>

        <section className="aboutus-section">
          <h2 className="aboutus-subtitle">Our Mission</h2>
          <p className="aboutus-text">
            <strong>Making global eCommerce easy, efficient, and profitable for everyone.</strong>
          </p>
          <p className="aboutus-text">
            We understand that online sellers need more than just suppliers – they need a dependable partner who helps them save time, reduce risks, and stand out from the competition. That's why we provide one-stop dropshipping solutions designed to simplify your business from sourcing to delivery.
          </p>
        </section>

        <section className="aboutus-section">
          <h2 className="aboutus-subtitle">What Makes Us Different</h2>
          <table className="aboutus-table">
            <thead>
              <tr>
                <th><strong>Our Strength</strong></th>
                <th><strong>What It Means</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Exclusive Collections</strong></td>
                <td>We offer unique and curated product lines that are only available through CH Dropshipping – helping you build a stronger brand identity and outshine competitors.</td>
              </tr>
              <tr>
                <td><strong>One-Stop Dropshipping</strong></td>
                <td>No inventory, no risk. We handle everything from warehousing to order fulfillment so you can focus on sales and marketing.</td>
              </tr>
              <tr>
                <td><strong>Automated Processes</strong></td>
                <td>Seamless integration with your store ensures real-time order syncing, inventory updates, and shipping tracking.</td>
              </tr>
              <tr>
                <td><strong>Verified Suppliers &amp; Quality Control</strong></td>
                <td>We carefully vet our suppliers and maintain strict quality checks to ensure consistent product standards and reliable shipping.</td>
              </tr>
              <tr>
                <td><strong>Fast &amp; Flexible Logistics</strong></td>
                <td>Multiple shipping options with trusted logistics partners ensure fast delivery and a smooth customer experience.</td>
              </tr>
              <tr>
                <td><strong>Dedicated Support Team</strong></td>
                <td>Our professional customer service team is always ready to assist you in solving issues and improving operations.</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="aboutus-section">
          <h2 className="aboutus-subtitle">Our Services</h2>
          <ul className="aboutus-list">
            <li><strong>Product Sourcing &amp; Customization</strong> – Partnering with top manufacturers, we provide private labeling, packaging, and branding services to help you create your own identity.</li>
            <li><strong>Order Fulfillment</strong> – From order placement to final delivery, CH Dropshipping automates and manages the entire fulfillment process for you.</li>
            <li><strong>Data-Driven Product Selection</strong> – We continuously analyze market trends and product performance to recommend new potential best-sellers.</li>
            <li><strong>After-Sales Protection</strong> – We offer responsive support, return and refund policies, and compensation mechanisms to minimize your business risks.</li>
          </ul>
        </section>

        <section className="aboutus-section">
          <h2 className="aboutus-subtitle">Our Vision</h2>
          <p className="aboutus-text">
            To become the most reliable and innovative dropshipping platform for global sellers.<br />
            At CH Dropshipping, we believe every entrepreneur deserves access to the same supply chain power as big brands – without the complexity or high costs.
          </p>
        </section>

        <section className="aboutus-section">
          <h2 className="aboutus-subtitle">Why Choose CH Dropshipping</h2>
          <p className="aboutus-text">
            While other platforms like DSers, CJdropshipping, and Doba provide broad access to products, CH Dropshipping focuses on <strong>exclusive collections</strong>, <strong>quality control</strong>, and <strong>personalized service</strong>.<br />
            We don't just help you sell – we help you <strong>stand out</strong>.
          </p>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default AboutUs;
